import "./style.css";

import { useState, useEffect, useContext } from "react";
import UmooveApi from "../../../components/api/UmooveApi";
import { useLocation, useNavigate } from "react-router-dom";
import mainContext from "../../../context/mainContext";
import StartFooter from "../../../components/Common/StartFooter";

import footerImg from "./Vector.svg";
let startFuncInterval = null;
function StartFocus() {
  const [mirror, setMirror] = useState("");
  const [startPressed, setStartPressed] = useState(false);
  const [RoundNumber, setRoundNumber] = useState(
    localStorage?.RoundNumber ? Number(localStorage?.RoundNumber) : 1
  );
  const [loadImg, setLoadImg] = useState(RoundNumber == 1 ? "loadImg" : "");
  const [lookingForEye, setLookingForEye] = useState(false)
  const navigate = useNavigate();
  let location = useLocation();
  const title = `START NEAR-POINT Round ${RoundNumber}/4`;
  const explanation1 =
    "Starting from arms length, press play and then slowly bring device towards your nose. When it starts to feel uncomfortable, or you see 2 Dots, click Pause, then, slightly bounce the device 3-4 times back and forth before pushing it slowly back to arms length while still focusing on the Dot";
  const explanation2 =
    "Now while looking at the dot, repeat the process";

  const {
    header: { setIsShowHeader },
    stream: { setStreamObj, streamObj },
    initCam: { alreadiInit, setAlreadyInit }
  } = useContext(mainContext);
  // console.log({ alreadiInit, loadImg, RoundNumber, windowNewData: window.newData });


  let [distances, setDistances] = useState([]);
  useEffect(() => {
    setIsShowHeader();
    if (!window.newData && !alreadiInit) {
      if (window.cordovaOn) {
        UmooveApi.API_loadUmooveLibrary()
        setAlreadyInit(true);//supposto handle with back history to prevant init again before i ride the navigate to dashbord
        setLoadImg("");
      } else {

        UmooveApi.API_loadUmooveLibrary()
          .then((stream) => {
            setMirror(stream)
            setAlreadyInit(true);//supposto handle with back history to prevant init again before i ride the navigate to dashbord
            setLoadImg("");
          })
          .catch((err) => console.log(err));
      }
    }
    console.log("location.state.dist", location?.state?.dist);
    if (location?.state?.dist) {
      setDistances([...distances, location?.state?.dist]);
    }
    return () => {

      clearInterval(startFuncInterval);
      setIsShowHeader(true);
      // localStorage.removeItem("RoundNumber");
    };
  }, []);






  function startFunction() {

    if (!startPressed) {//handle with duble click
      setStartPressed(true)
    } else {
      console.log("you cant press 2 times")
      return
    }

    let count = 0;
    if (!window.newData) {
      if (!window.cordovaOn) {
        UmooveApi.API_startUmoove();

      } else {
        if (!window.isUmoovePluginInit) {
          UmooveApi.API_loadUmooveLibrary()
        } else if (!window.isUmoovePluginStart) {
          UmooveApi.API_startUmoove(true);
        }

      }
    }


    startFuncInterval = setInterval(() => {
      // console.log("Face", UmooveApi.API_getUmooveTracking(), "count", count);
      if (UmooveApi.API_getUmooveTracking() && count > 4) {
        clearInterval(startFuncInterval);
        UmooveApi.API_startUmoove(false);
        setLookingForEye(false);
        navigate("/train-focus/exercise", {
          state: { distances: [...distances] },
        });
      } else if (count < 200) {
        count++;
      } else {
        console.log("Look at the camera");
        setLookingForEye(true);
        count = 0;
      }
    }, 10);
  }



  return (
    <div>
      <div
        className="localLook"
        style={{ left: Number(localStorage.getItem("posX")) + "px" }}
      >
        <div className="purpleDotDot"></div>
        <div className="arrowToDot"></div>
        <div className="anderDotText">
          {lookingForEye ? <p>We're looking for your eyes</p> :
            RoundNumber == 1 ?
              <p>After reading the instructions focus on the Dot</p> : ""
          }
        </div>

        {!window.cordovaOn && <video style={{ opacity: "0" }} width="320" height="240">
          <source src={mirror} type="video/mp4"></source>
        </video>}
      </div>

      <StartFooter
        startFunction={startFunction}
        title={title}
        explanation={RoundNumber === 1 ? explanation1 : explanation2}
        img={footerImg}
        loader={loadImg}
      />
    </div>
  );
}

export default StartFocus;
